'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = enforceSettingsRules;

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function enforceSettingsRules(settings) {
  (0, _invariant2.default)(settings.constructor === Object, 'AppConfigContainer: Steps must be a JS Object. Found `%s`', settings.constructor.name);
  (0, _invariant2.default)(settings.appName && typeof settings.appName === 'string', 'AppConfigContainer: "appName" attribute is required in config and' + ' it must be of type "string". Found `%s`', _typeof(settings.appName));
  (0, _invariant2.default)(settings.onComplete && typeof settings.onComplete === 'function', 'AppConfigContainer: "onComplete" attribute is required in config and' + ' it must be of type "function". Found `%s`', _typeof(settings.onComplete));
  (0, _invariant2.default)(settings.steps, 'AppConfigContainer: "steps" attribute is required in config');
  (0, _invariant2.default)(settings.signupProduct, 'AppConfigContainer: "signupProduct" attribute is required in config');
  (0, _invariant2.default)(settings.baseHistoryPath && typeof settings.baseHistoryPath === 'string', 'AppConfigContainer: "baseHistoryPath" attribute is required in config and' + ' it must be of type "string". Found `%s`', _typeof(settings.onComplete));
  (0, _invariant2.default)(!settings.landingPageContent || settings.landingPageContent.constructor === Object, 'AppConfigContainer: "landingPageContent" attribute must be a JS Object. Found `%s`', _typeof(settings.landingPageContent));
}
module.exports = exports['default'];